<template lang="html">
  <div class="job-card-container">
    <div class="header d-flex justify-content-between px-3 align-items-center">
      <div class="">
        <h2>
          {{ $t("feature.homecare.job_id") }}
          {{ job.job_order_no | job-no }}
        </h2>
        <span class="time">{{ job.job_order_date | moment-full }}</span>
      </div>
      <div class="">
        <div class="status-label">{{ $t("feature.homecare.job_status") }}</div>
        <div
          :class="[job.job_order_status_code]"
          class="status homecare-status"
        >
          {{ $t("feature.homecare.status." + job.job_order_status_code) }}
        </div>
      </div>
    </div>
    <nav class="nav d-flex">
      <a
        v-if="job_ordes.length > 0"
        :class="{ active: tabIndex === 0 }"
        class="nav-link"
        @click="changeTab(0)"
      >
        <span>{{ $t("feature.homecare.fixing_list") }}</span>
        <small
          >{{ job_ordes.length }} {{ $t("feature.homecare.job_unit") }}</small
        >
      </a>
      <a
        :class="{ active: tabIndex === 1 }"
        class="nav-link"
        @click="changeTab(1)"
      >
        <span>{{ $t("feature.homecare.inform_list") }}</span>
        <small
          >{{ request_items.length }}
          {{ $t("feature.homecare.job_unit") }}</small
        >
      </a>
    </nav>
    <div class="tab-container">
      <fix-list
        v-show="tabIndex === 0"
        v-if="job_ordes.length > 0"
        :items="job_ordes"
      />
      <inform-list v-show="tabIndex === 1" :items="request_items" />
    </div>
  </div>
</template>

<script>
import FixList from "./FixList"
import InformList from "./InformList"

export default {
  components: {
    FixList,
    InformList,
  },
  props: {
    job: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      tabIndex: 1,
    }
  },
  computed: {
    job_ordes() {
      if (this.job && this.job.request_items) {
        return this.job.job_order_items
        // return this.job.request_items;
      }
      return []
    },
    request_items() {
      if (this.job && this.job.request_items) {
        return this.job.request_items
      }
      return []
    },
  },
  watch: {
    job() {
      this.tabIndex = this.job_ordes.length > 0 ? 0 : 1
    },
  },
  mounted() {
    this.tabIndex = this.job_ordes.length > 0 ? 0 : 1
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
    },
  },
}
</script>

<style lang="scss" scoped>
.job-card-container {
  background: white;
  padding: 0;
  border-right: solid 1px #e0e0e0;
}
.header {
  max-height: 65px;
  height: 65px;
  flex-grow: 1;
  flex-shrink: 0;
  border-bottom: 1px solid #e0e0e0;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
  }
  .time {
    color: #4a4a4a;
    font-size: 12px;
  }
  .status-label {
    font-size: 11px;
  }
  .status {
    font-size: 18px;
    font-weight: bold;
  }
}
.nav {
  max-height: 58px;
  height: 58px;
  flex-grow: 1;
  flex-shrink: 0;
  .nav-link {
    padding: 8px 0;
    text-align: center;
    display: block;
    flex: 1 0 0;
    max-width: 100%;
    border-bottom: solid 1px #e0e0e0;
    cursor: pointer;
    &.active {
      border-bottom: 2px solid #e27024;
    }
    span,
    small {
      display: block;
      color: #000000;
    }
    span {
      font-size: 16px;
      font-weight: 500;
    }
    small {
      font-size: 11px;
      font-weight: 500;
    }
  }
}
.tab-container {
  overflow: auto;
}
</style>
